import { ResponsiveImageProps, ImageGroup } from './types'
import viewportHelper from '@content/helpers/src/viewport.helpers.ts'
import Image from '../image/Image.tsx'

const ResponsiveImage = ({ mobile, desktop, retina }: ImageGroup) => {
    const isValid = (img?: ResponsiveImageProps) => !!img?.src && !!img?.alt

    // mobile view
    if (viewportHelper.is.mobile && isValid(mobile)) {
        return <Image {...mobile!} />
    }

    // retina view
    if (viewportHelper.is.retina && isValid(retina)) {
        return <Image {...retina!} />
    }

    // fallback to desktop (always present)
    return <Image {...desktop} />
}
export default ResponsiveImage
